import { InlineStack as InlineStack$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const InlineStack = createRemoteReactComponent(InlineStack$1);

export { InlineStack };
